
import { css } from 'lit';
export default css`
:host {
  display: block;
  height: 100%;
}@media (min-width: 768px) {:host {
    height: auto;
  }
}

.location-card {
  position: relative;
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.location-card__number {
  margin-right: 1.5rem;
}

.location-card__number {
  display: none;
}

.location-card__number {
  align-items: center;
}

.location-card__number {
  font-family: adobe-caslon-pro, Adobe Caslon Pro, EB Garamond, serif;
}

.location-card__number {
  font-size: 2.5rem;
}

.location-card__number {
  font-weight: 700;
}

.location-card__number {
  letter-spacing: -0.046875rem;
}

.location-card__number {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

.location-card__bottom-container {
  display: flex;
}

.location-card__address-text {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}

.location-card__icon {
  margin-left: 0.25rem;
}

.location-card__icon {
  height: 1rem;
}

.location-card__icon {
  width: 1rem;
}

.location-card__link {
  margin-top: 1rem;
}

.location-card__link {
  width: 100%;
}

.location-card__anchor {
    /* pt-1 used to offset the link text that doesn't perfectly center in line */
  }

.location-card__anchor {
  display: flex;
}

.location-card__anchor {
  align-items: center;
}

.location-card__anchor {
  justify-content: center;
}

.location-card__anchor {
  padding-top: 0.25rem;
}

.location-card__location-icon {
  margin-right: 0.25rem;
}

.location-card__location-icon {
  width: 1rem;
}

.location-card__image-list {
  margin-top: 1.5rem;
}

.location-card__image-list {
  display: none;
}

.location-card__image-list {
  width: 100%;
}

.location-card__image-list {
    -o-object-fit: cover;
       object-fit: cover;
}

@media (min-width: 1024px) {.location-card__image-list {
    margin-top: 1.5rem;
  }
}

.location-card__image-list {
    height: 250px;
  }

@media (min-width: 1024px) {

.location-card__image-list {
      height: 192px;
      max-width: 215px;
      display: block
  }
    }

.location-card__image-map {
  width: 100%;
}

.location-card__image-map {
    -o-object-fit: cover;
       object-fit: cover;
}

.location-card__image-map {
    height: 160px;
  }

.location-card__body-list {
  margin-top: 1.5rem;
}

.location-card__body-list {
  display: flex;
}

.location-card__body-list {
  flex-direction: column;
}

.location-card__body-list {
  align-items: flex-start;
}

.location-card__body-list {
  justify-content: center;
}

.location-card__body-list {
  justify-content: space-between;
}

@media (min-width: 1024px) {.location-card__body-list {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

.location-card__body-map {
  display: flex;
}

.location-card__body-map {
  flex-direction: column;
}

.location-card__body-map {
  align-items: flex-start;
}

.location-card__body-map {
  justify-content: center;
}

.location-card__body-map {
  justify-content: space-between;
}

.location-card__body-map {
  margin-top: 0px;
}

.location-card__body-map {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

.location-card__body-map {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.location-card__address {
  font-size: 0.9375rem;
}

.location-card.card--list {
  position: relative;
}

.location-card.card--list {
  flex-direction: column;
}

.location-card.card--list {
  border-bottom-width: 1px;
}

.location-card.card--list {
  --tw-border-opacity: 1;
  border-color: rgba(242, 242, 242, var(--tw-border-opacity));
}

.location-card.card--list {
  padding-bottom: 1.5rem;
}

.location-card.card--list {
  padding-left: 1.5rem;
}

@media (min-width: 1024px) {.location-card.card--list {
    display: flex;
  }
}

@media (min-width: 1024px) {.location-card.card--list {
    flex-direction: row;
  }
}

@media (min-width: 1024px) {.location-card.card--list:before {
    position: absolute;
  }
}

@media (min-width: 1024px) {.location-card.card--list:before {
    top: 0px;
  }
}

@media (min-width: 1024px) {.location-card.card--list:before {
    left: 0px;
  }
}

@media (min-width: 1024px) {.location-card.card--list:before {
    display: block;
  }
}

@media (min-width: 1024px) {.location-card.card--list:before {
    height: 2px;
  }
}

@media (min-width: 1024px) {.location-card.card--list:before {
    --tw-bg-opacity: 1;
    background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
  }
}

@media (min-width: 1024px) {.location-card.card--list:after {
    position: absolute;
  }
}

@media (min-width: 1024px) {.location-card.card--list:after {
    bottom: 0px;
  }
}

@media (min-width: 1024px) {.location-card.card--list:after {
    left: 0px;
  }
}

@media (min-width: 1024px) {.location-card.card--list:after {
    display: block;
  }
}

@media (min-width: 1024px) {.location-card.card--list:after {
    height: 2px;
  }
}

@media (min-width: 1024px) {.location-card.card--list:after {
    --tw-bg-opacity: 1;
    background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
  }
}

.location-card.card--list:hover:after, .location-card.card--list:hover:before {
        width: 100%;
        content: '';
      }

.location-card.card--list:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(242, 235, 246, var(--tw-bg-opacity));
}

.location-card.card--map {
  width: 100%;
}

.location-card.card--map {
    max-width: 320px;
  }

@media (min-width: 640px) {.location-card.card--map .location-card__body {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

@media (min-width: 640px) {.location-card.card--map .location-card__body {
    padding-top: 0px;
  }
}

/* Ugly workaround required here because of css specificity (we need to update line 65) */

.location-card.card--map.block {
  position: absolute;
}

.location-card.card--map.block {
  height: 100%;
}

.location-card.card--map.block {
  background-color: transparent;
}

@media (min-width: 768px) {.location-card.card--map.block {
    position: relative;
  }
}

@media (min-width: 768px) {.location-card.card--map.block {
    height: auto;
  }
}

@media (min-width: 768px) {.location-card.card--map.block {
    --tw-bg-opacity: 1;
    background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  }
}

.location-card.card--map.block {
    max-width: initial;
  }

@media (min-width: 768px) {

.location-card.card--map.block {
      max-width: 320px
  }
    }

.location-card.card--map.block .location-card__body-map {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.location-card.card--map.block .location-card__body-map {
      justify-content: flex-start;
      padding-left: 30%;
      height: 72%;
    }

@media (min-width: 768px) {

.location-card.card--map.block .location-card__body-map {
        height: auto;
        justify-content: space-between;
        padding-left: 2.5rem
    }
      }
`;